import React, { createElement, useState } from 'react';

const withHover = <T extends React.ComponentType>(WrappedComponent: T, isBlock = true): T => {
    return ((props) => {
        const [isHover, setIsHover] = useState(false);

        // 默认块级布局，或者如果 style 里直接指定了相关的 css 也可以是块级布局
        return isBlock || props.style?.display === 'block' || props.style?.display === 'flex' ? (
            <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                <WrappedComponent
                    {...props}
                    style={isHover ? { ...props.style, ...props.hoverStyle } : props.style}
                />
            </div>
        ) : (
            <span onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                <WrappedComponent
                    {...props}
                    style={isHover ? { ...props.style, ...props.hoverStyle } : props.style}
                />
            </span>
        );
    }) as unknown as T;
};

export default withHover;
